import React from 'react'
import { useActions, useValues } from 'kea'

import I18n from 'lib/i18n'
import Textarea from 'lib/forms/textarea-autosize'
import BreakOnBr from 'lib/tags/break-on-br'
import redirect from 'lib/utils/redirect-url'
import displayProfileName from 'lib/utils/display-profile-name'

import courseLogic from '~/scenes/course/show/logic'

const noop = () => {}

export default function Question () {
  const {
    course: { messageUrl, messageUrlIsInbox },
    user: { firstName },
    windowWidth
  } = useValues(courseLogic)
  const { openModal } = useActions(courseLogic)

  const shortenedFirstName = displayProfileName(firstName)

  const handleMessageClick = () => {
    if (!messageUrlIsInbox && windowWidth >= 760) {
      openModal()
    } else {
      redirect(messageUrl)
    }
  }

  return (
    <div className='widget nospace white'>
      <h3 className='boxtitle line'>{I18n.t('courses.show_contact.title')}</h3>

      <div className='padding-no-top2'>
        <div className='mb-10'>{I18n.t('courses.show_contact.label', { first_name: firstName })}</div>
        <Textarea
          neverFocus
          value=''
          onValueChange={noop}
          onClick={handleMessageClick}
          placeholder={<BreakOnBr text={I18n.t('courses.show_contact.placeholder', { first_name: firstName })} />}
          style={{
            width: '100%',
            boxSizing: 'border-box',
            marginBottom: 10
          }}
        />

        <button className='contact-style class-button' onClick={handleMessageClick}>
          {I18n.t('courses.show_contact.button', { first_name: shortenedFirstName })}
        </button>
      </div>
    </div>
  )
}
